import React, { useState, useCallback, useLayoutEffect } from "react";
import HttpAction from "modules/utils/HttpAction";
import ObjectList from "../../utils/ObjectList";

const AdminContext = React.createContext({
  state: {
    teamList: {},
    rankInfo: {},
    submitList: {},
    adminContestInfo: {},
    renderData: { //화면 랜더링시 사용
      posterImg: "", //포스터 이미지 아이디
      posterImgUrl: "", //포스터 이미지 URL
      bgImg: "", //배경이미지
      sponsor: [], //Step1. 주최
      host: [], //Step1. 주관
      contestDatasetFile: [] //Step3. 파일 첨부
    },
    contestData: {
      contestInfo: {
        bigCategory: "", // 대분류
        smallCategory: "", // 소분류
        contestId: "", //대회정보 아이디
        useFlg: "N", //임시저장 유무
        contestTitle: "", //챌린지 제목
        contestObjective: "",  // 챌린지 목표
        contestParticipantDesc: "", // 참가대상
        contestPosterImgFile: "", //챌린지 포스터아이디
        contestPosterImgFileUrl: "", //챌린지 포스터 URL
        contestBgImgFile: "", //챌린지 배경
        contestExtraInfoDesc: "",  // 상금 외 기타 정보
        contestGroundRuleDesc: "", // 기본규칙
        contestFailDesc: "", // 실격처리
        contestEvaluationDesc: "", // 평가형식
        contestSubmitFileFormatDesc: "", // 제출파일 포맷
        contestDatasetDesc: "", // 데이터 셋 설명
        baselineCode: "", // 베이스코드
        contestPicMberId: "", //담당자명
        contestPicMberEmail: "", //이메일
        contestPicBizNumber: "", //사업자번호
        contestBizNumber1: "", //사업자번호 첫번째
        contestBizNumber2: "",//사업자번호 두번째
        contestBizNumber3: "",//사업자번호 세번째
        participateAgreement: "",
        securityAgreement: "",
      },
      contestObjectiveList: ObjectList, // 챌린지목표 목록
      files: { //파일정보
        sponsor: [], //Step1. 주최
        host: [], //Step1. 주관
        contestDatasetFile: [] //Step3. 파일 첨부
      },
      youtubeLinkList: [],
      previewLinkList: [],
      prize: [
        { contestPrizeAmount: 0, contestPrizeCount: 0 },
        { contestPrizeAmount: 0, contestPrizeCount: 0 }
      ],
      schedule: {
        scheduleLabelList: [
          "시작일",
          "팀원모집마감",
          "종료일",
          "결과발표"
        ],
        scheduleDateList: [
          "",
          "",
          "",
          ""
        ]
      }
    }
  },
  actions: {
    getTeamList: () => { },
    getRankInfo: () => { },
    saveRank: () => { },
    deleteRank: () => { },
    getSubmitList: () => { },
    getAdminContestInfo: () => { },
    getAdminContestData: () => { }
  },
});

const AdminProvider = ({ children }) => {
  const [teamList, setTeamList] = useState([]);
  const [rankInfo, setRankInfo] = useState({});
  const [submitList, setSubmitList] = useState([])
  const [adminContestInfo, setAdminContestInfo] = useState();
  const [renderData, setRenderData] = useState({
    posterImg: "", //포스터 이미지 아이디
    posterImgUrl: "", //포스터 이미지 URL
    bgImg: "", //배경이미지
    sponsor: [], //Step1. 주최
    host: [], //Step1. 주관
    contestDatasetFile: [] //Step3. 파일 첨부
  });

  const [contestData, setContestData] = useState({
    contestInfo: {
      bigCategory: "", // 대분류
      smallCategory: "", // 소분류
      contestId: "", //대회정보 아이디
      useFlg: "", //임시저장 유무
      contestTitle: "", //챌린지 제목
      contestObjective: "",  // 챌린지 목표
      contestParticipantDesc: "", // 참가대상
      contestPosterImgFile: "", //챌린지 포스터아이디
      contestPosterImgFileUrl: "", //챌린지 포스터 URL
      // contestBgImgFile: "", //챌린지 배경
      contestExtraInfoDesc: "",  // 상금 외 기타 정보
      contestGroundRuleDesc: "", // 기본규칙
      contestFailDesc: "", // 실격처리
      contestEvaluationDesc: "", // 평가형식
      contestSubmitFileFormatDesc: "", // 제출파일 포맷
      contestDatasetDesc: "", // 데이터 셋 설명
      baselineCode: "", // 베이스코드
      contestPicMberId: "", //담당자명
      contestPicMberEmail: "", //이메일
      contestPicBizNumber: "", //사업자번호
      contestBizNumber1: "", //사업자번호 첫번째
      contestBizNumber2: "",//사업자번호 두번째
      contestBizNumber3: "",//사업자번호 세번째
      tempFlg: "", //임시저장 플래그 유무
      participateAgreement: "",
      securityAgreement: "",
    },
    contestObjectiveList: ObjectList, // 챌린지목표 목록
    files: { //파일정보
      sponsor: [], //Step1. 주최
      host: [], //Step1. 주관
      contestDatasetFile: {
      } //Step3. 파일 첨부
    },
    youtubeLinkList: [],
    previewLinkList: [],
    prize: [
      { contestPrizeAmount: 0, contestPrizeCount: 0 },
      { contestPrizeAmount: 0, contestPrizeCount: 0 }
    ],
    schedule: {
      scheduleLabelList: [
        "시작일",
        "팀원모집마감",
        "종료일",
        "결과발표"
      ],
      scheduleDateList: [
        "",
        "",
        "",
        ""
      ]
    }
  });

  // 대회 수정 조회
  const getAdminContestData = useCallback((contestId) => {
    HttpAction({
      url: "/admin/contest/update",
      method: "get",
      params: {
        contestId: contestId && contestId
      }
    }).then((res) => {
      if (res.code === 200) {
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ", res.data)
        let getData = res.data;
        //사업자번호 받아와서 쪼개주기
        const biznumber = getData.contestInfo.contestPicBizNumber.split("-");
        getData.contestInfo.contestBizNumber1 = biznumber[0];
        getData.contestInfo.contestBizNumber2 = biznumber[1];
        getData.contestInfo.contestBizNumber3 = biznumber[2];

        //주최 base64정보 붙여주기
        const sponsor = [];
        const host = [];
        getData.files.sponsor.map((item, index) => {
          sponsor.push(`${item.file}`);
        });
        getData.files.host.map((item, index) => {
          host.push(`${item.file}`);
        });
        setRenderData({
          ...renderData,
          posterImg: getData.contestInfo.contestPosterImgFile,
          posterImgUrl: getData.contestInfo.contestPosterImgFileUrl,
          bgImg: getData.contestInfo.contestBgImgFile,
          sponsor: sponsor,
          host: host
        });

        //
        setContestData(getData);
      } else {
        console.log("Error", res)
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  // 팀 정보 조회
  const getAdminContestInfo = useCallback(() => {
    HttpAction({
      url: "/admin/contest",
      method: "get"
    }).then((res) => {
      if (res.code === 200) {
        setContestData(res.data);
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  const getRankInfo = useCallback((contestId) => {
    HttpAction({
      url: "/admin/rank",
      method: "get",
      params: {
        contestId: contestId
      }
    }).then((res) => {
      if (res.code === 200) {
        setRankInfo(res.data);
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  // 팀 정보 조회
  const getSubmitList = useCallback((contestId) => {
    HttpAction({
      url: "/admin/rank/submit",
      method: "get",
      params: {
        contestId: contestId
      }
    }).then((res) => {
      if (res.code === 200) {
        setSubmitList(res.data);
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  // 팀 정보 조회
  const getTeamList = useCallback((contestId, teamName) => {
    HttpAction({
      url: "/admin/team/rank",
      method: "get",
      params: {
        contestId: contestId,
        teamName: teamName
      }
    }).then((res) => {
      if (res.code === 200) {
        setTeamList(res.data);
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);

  const saveRank = (contestId, teamId, rank) => {
    HttpAction({
      url: "admin/rank",
      method: "post",
      params: {
        contestId: contestId,
        teamId: teamId,
        rank: rank
      },
      headers: { "Content-Type": "text/plain" }
    }).then((res) => {
      if (res.code === 200) {
        getRankInfo(contestId)
        console.log('res', res)
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }

  const deleteRank = useCallback((contestId, teamId) => {
    HttpAction({
      url: "/admin/rank",
      method: "delete",
      params: {
        contestId: contestId,
        teamId: teamId
      },
    }).then((res) => {
      if (res.code === 200) {
        getRankInfo(contestId)
      } else {
      }
    }).catch(e => {
      // alert(e)
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("loginid");
      let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
      // document.location.href = "/main"
    });
  }, []);


  const value = {
    state: { teamList, rankInfo, submitList, adminContestInfo, contestData, renderData },
    actions: { getTeamList, getSubmitList, getRankInfo, saveRank, deleteRank, getAdminContestInfo, getAdminContestData, setContestData, setRenderData },
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};

const { Consumer: AdminConsumer } = AdminContext;

export { AdminProvider, AdminConsumer, AdminContext };

export default AdminContext;